/**
 * Shared constants for the Search Results Map feature.
 *
 * @module searchResultsMap/constants
 */

/**
 * Minimum zoom level required for a rectangular-area search.
 *
 * Used in two places that must stay aligned:
 *
 *  1. `map.plugin` — sets the **initial zoom** when the map first loads with
 *     a `rectangularArea` location type. This ensures the map never opens
 *     below the constraint enforced during the session.
 *
 *  2. `searchWithinMap.plugin` — applies this min zoom whenever the location
 *     type transitions to `RECTANGULAR_AREA`, preventing the user from zooming
 *     out to a level where the bounding box would cover an impractically large area.
 *
 * If the value needs to change, update it here only.
 */
export const RECTANGULAR_AREA_MIN_ZOOM = 9;

/**
 * Default minimum zoom level used outside of a rectangular-area search.
 */
export const DEFAULT_MIN_ZOOM = 5;

/**
 * Maximum zoom level for the map, used to prevent users from zooming in too far and breaking the experience.
 */
export const DEFAULT_MAX_ZOOM = 20;

/**
 * Minimum zoom level at which site plans are rendered.
 * Must stay in sync with the MIN_ZOOM constant in
 * sitePlan.plugin and interactiveSitePlan.plugin.
 */
export const SITE_PLAN_RENDER_ZOOM_THRESHOLD = 14;